import React from 'react';

import { MultiStepModal } from '../../multiStepModal';
import { AccountTypePickerModalStep } from './steps/accountTypePickerModalStep';
import { AccountTypeFormModalStep } from './steps/accountTypeFormModalStep';
import { AccountPickerModalStep } from './steps/accountPickerModalStep';
import { DeleteAccountConfirmationModalStep } from './steps/deleteAccountConfirmationModalStep';
import { AccountEditFormModalStep } from './steps/accountEditFormModalStep';
import { useDesignVariant } from '../designVariantContext';

interface SelectAccountModalProps {
  open: boolean;
  onClose: () => void;
  selectedAccountId?: string;
  initialAccountId?: string;
}

export const SelectAccountModal: React.FC<SelectAccountModalProps> = ({
  open,
  onClose,
  selectedAccountId,
  initialAccountId,
}) => {
  const variant = useDesignVariant();

  return (
    <MultiStepModal
      showCross
      variant={variant}
      steps={{
        key: 'accountPicker',
        title: 'Select a cloud account to connect',
        component: () => (
          <AccountPickerModalStep
            selectedAccountId={selectedAccountId}
            initialAccountId={initialAccountId}
          />
        ),
        children: [
          {
            key: 'accountTypePicker',
            title: 'Create account to connect',
            component: () => <AccountTypePickerModalStep />,
            children: [
              {
                key: 'accountTypeForm',
                title: 'Configure account',
                component: () => <AccountTypeFormModalStep />,
              },
            ],
          },
          {
            key: 'deleteAccountConfirmation',
            title: 'Delete account?',
            component: () => <DeleteAccountConfirmationModalStep />,
          },
          {
            key: 'editAccountForm',
            title: 'Edit account',
            component: () => <AccountEditFormModalStep />,
          },
        ],
      }}
      open={open}
      onClose={onClose}
      breadcrumb={{ hide: true }}
      size="lg"
    />
  );
};
